import { Stack } from "@mui/material";
import { Outlet } from "react-router";
// import Snowfall from "react-snowfall";
// import { useSettings } from "src/hooks";
import { SideMenu } from "./SideMenu";

const SideMenuLayout = () => {
  // const { featureFlags } = useSettings();

  return (
    <Stack direction="row">
      {/* {featureFlags.snowfall && (
        <Snowfall snowflakeCount={300} color="#94c3c980" style={{ position: "fixed", zIndex: 9999 }} />
      )} */}

      <SideMenu />
      <Outlet />
    </Stack>
  );
};

export { SideMenuLayout };
